module.exports = __webpack_public_path__ + "media/images/pages/trade-journaling-e90fa6f4da5f65531ea728cdcbe5a8a8.svg";